import { observer } from "mobx-react";
import React from "react";

import { useTranslation } from "react-i18next";

import { SharedLoaderSpinner } from "@components/loader/shared";
import LinkActiveEventsHOC from "@features/my-bets/mobile/common/event-offer-groups/LinkActiveEventsHOC";
import OfferGroup from "@features/my-bets/mobile/common/event-offer-groups/components/OfferGroup";
import Title from "@features/my-bets/mobile/common/event-offer-groups/components/Title";
import { Bet } from "@models";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";

import { BetDetailsBetCancelButton, BetDetailsBetReuseButton } from "../common";

export const BetDetailsModalMarkets = observer(
	function BetDetailsModalMarkets(props: {
		isActive: boolean;
		store: BetDetailsModalStore | BetSlipReceiptModalStore;
		betSlip: Bet;
	}) {
		const { t } = useTranslation();

		if (!props.isActive) {
			return null;
		}

		if (props.store.loader.isLoading) {
			return (
				<div className="loader">
					<SharedLoaderSpinner />
				</div>
			);
		}

		return (
			<>
				<div className="bet--mini__row u-mar--bottom--xsml">
					<div className="bet--mini__col">
						<span className="bet--mini__col__title">
							{t("BET_SLIP.MAX_COEF")}:
						</span>
						<div className="bet--mini__col__title--bold">
							{props.betSlip.maxCoefficient.toFixed(2)}
						</div>
					</div>
					<div className="bet--mini__col">
						<span className="bet--mini__col__title">
							{t("BET_SLIP.PAYMENT")}:
						</span>
						<div className="bet--mini__col__title--bold">
							{props.betSlip.payment}
						</div>
					</div>
					<div className="bet--mini__col">
						<span className="bet--mini__col__title">
							{t("BET_SLIP.MAX_GAIN")}:
						</span>
						<div className="bet--mini__col__title--bold">
							{props.betSlip.maxGain}
						</div>
					</div>
				</div>
				<div className="popup__ticket bet">
					<MyBetsBetContext.Provider value={props.betSlip}>
						{props.betSlip.groupedOffersByEvent.map(
							(offerGroup) => {
								return (
									<div
										key={offerGroup[0].eventId}
										className="bet__item"
									>
										<LinkActiveEventsHOC
											className="bet__team bet__link"
											offer={offerGroup[0]}
										>
											<Title
												offer={offerGroup[0]}
												groupHasTitle={true}
												titleHasScore={true}
											/>
											<OfferGroup
												offerGroup={offerGroup}
												groupHasTitle={true}
												offersHaveColor={true}
												isPopup
											/>
										</LinkActiveEventsHOC>
									</div>
								);
							}
						)}
					</MyBetsBetContext.Provider>
				</div>
				<div className="bet--mini__actions ">
					{!props.store.isBetCancelOpen &&
						!props.store.isAutoSellOpen &&
						!props.store.isCashoutOpen && (
							<div className="bet--mini__actions__col">
								<BetDetailsBetCancelButton
									store={props.store}
									bet={props.betSlip}
								/>
								<BetDetailsBetReuseButton
									store={props.store}
									bet={props.betSlip}
								/>
							</div>
						)}
				</div>
			</>
		);
	}
);
